import { Control } from "react-hook-form";
import { ChangeEvent, FormEventHandler } from "react";
import { Buttons } from "../../../atoms/Buttons";
import { ControlText } from "../../../atoms/controls/ControlText";
import { ControlSelect } from "../../../atoms/controls/ControlSelect";
import { SelectOption } from "../../../../common/types/selectOption";
import { ModalProps, Modals } from "..";
import { InputFileList } from "../../../atoms/Inputs/InputFileList";

interface ModalTechDocProps extends ModalProps {
  control: Control<any>;
  onSubmit: FormEventHandler;
  select: {
    dcmTypeName?: string;
    dcmMcyName?: string;
    dcmTitle?: string;
  };
  machinerySelectOptions: SelectOption[] | undefined;
  documentTypeSelectOptions: SelectOption[] | undefined;
  handleMcySelectChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  handleTypeSelectChange: (e: ChangeEvent<HTMLSelectElement>) => void;
}

export const ModalTechDoc = ({
  onSubmit,
  formId,
  select,
  control,
  setModalShow,
  machinerySelectOptions,
  documentTypeSelectOptions,
  handleMcySelectChange,
  handleTypeSelectChange,
}: ModalTechDocProps) => {
  return (
    <Modals
      modalTitle="기술문서 파일 등록"
      formId={formId}
      setModalShow={setModalShow}
      modalButtons={
        <>
          <Buttons
            type="submit"
            size="md"
            layout="primary"
            label="저장"
            form={formId}
            onClick={onSubmit}
          />
          <Buttons
            type="button"
            size="md"
            layout="secondary"
            label="취소"
            onClick={() => setModalShow(false)}
          />
        </>
      }
    >
      <>
        <ControlSelect
          name="dcmTypeName"
          control={control}
          options={documentTypeSelectOptions}
          onChange={handleTypeSelectChange}
          direction="column"
          size="md"
          width={500}
          label="문서 유형"
          placeholder="문서 유형 선택"
          erroredTxt="문서 유형을 선택하세요."
        />
        <ControlSelect
          name="dcmMcyName"
          control={control}
          options={machinerySelectOptions}
          onChange={handleMcySelectChange}
          direction="column"
          size="md"
          width={500}
          label="장비명"
          placeholder="장비명 선택"
          erroredTxt="장비명을 선택하세요."
        />
        <ControlText
          name="dcmTitle"
          control={control}
          direction="column"
          size="md"
          width={500}
          label="문서 제목"
          placeholder="문서 제목을 입력하세요."
        />
        <InputFileList name="file" control={control} width={500} />
      </>
    </Modals>
  );
};
